import * as React from 'react';

import { type DateValue } from '@internationalized/date';
import { Button, Col, DateRangePicker, Row } from '@rematter/ui-web';
import { type WritableAtom, useAtom } from 'jotai';

import { useTranslations } from '../../../i18n/useTranslations';

type DateRange = { start: DateValue; end: DateValue };

interface DateRangeColumnFilterProps {
  stateAtom: WritableAtom<DateRange | null, [DateRange | null], void>;
  label: string;
  ariaLabel: string;
  onClose?: () => void;
}

//
// ⚛️ ⚛️ ⚛️ DATE RANGE COLUMN FILTER ⚛️ ⚛️ ⚛️
//
export const DateRangeColumnFilter: React.FC<DateRangeColumnFilterProps> = ({
  stateAtom,
  label,
  ariaLabel,
  onClose,
}) => {
  const t = useTranslations();

  // Atoms
  const [dateRange, setDateRange] = useAtom(stateAtom);

  // Callbacks
  const handleReset = React.useCallback(() => {
    setDateRange(null);
  }, [setDateRange]);

  return (
    <Col gap3 className="@DateRangeColumnFilter min-h-35 min-w-[300px] p-3">
      <DateRangePicker
        value={dateRange}
        onChange={setDateRange}
        label={label}
        aria-label={ariaLabel}
      />

      <Row gap2 xEnd yEnd className="flex-1 border-t border-neutral/20 pt-2">
        <Button
          variant="outline"
          onPress={handleReset}
          color="neutral"
          isDisabled={!dateRange}
        >
          {t.transactionsView.filters.receivedDate.clear}
        </Button>
        <Button variant="solid" onPress={onClose}>
          {t.transactionsView.filters.receivedDate.done}
        </Button>
      </Row>
    </Col>
  );
};
